import React from 'react'
import { Col, Row } from 'reactstrap'

const PathogenComparison = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4 bg-img' style={{ backgroundImage:'url("pathogen-testing/ULC-Testing-bg-v1.png")'}}>
            <Row className=''>
                <Col md='12' lg='7' className='pe-md-5'>
                    <div className='fs-ss-24 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                    United Lab Care Respiratory Pathogen Panels Have Been Demonstrated Compared To Other Diagnostic Testing.
                    </div>
                    <div className=''>
                        <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                    </div>

                    <div className='pt-3'>
                        <ol type='1' className='fs-ss-16 text-montserrat fw-600 text-ss-black ps-3' style={{ letterSpacing:'0.5px'}}>
                            <li className='py-1'>Boost diagnostic yield: Identity up to 50% more infections than conventional approaches.</li>
                            
                            <li className='py-1'>Reduce the use of unneeded medicines: 30% fewer prescriptions were written for antibiotics.</li>
                            
                            <li className='py-1'>Reduce unnecessary tests and procedures; chest x-rays, for example, have been decreased by 19%.</li>
                            
                            <li className='py-1'>Including a SARS-CoV-2 detection test.</li>
                        </ol>
                    </div>
                </Col>

                <Col md='12' lg='5' className='flex-center'>
                    <div className='flex-center'>
                        <img src='pathogen-testing/RPP-Testing-img2.png' alt='' height='auto' width='75%' className='img-8' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default PathogenComparison